import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IConfigurations } from '../../../../public/assets/Configurations/IConfigurations.model';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationManagerService {
  static settings: IConfigurations
  static configSettings: any;
  constructor(private http: HttpClient) { }

  async load(): Promise<void> {
    try {
      const success = await firstValueFrom(this.http.get(environment.configFile));
      ConfigurationManagerService.settings = <IConfigurations>JSON.parse(JSON.stringify(success));
      
      const defaultConfig = await firstValueFrom(this.http.get<any>('/assets/config/default.json'));
      const envConfig = await firstValueFrom(this.http.get<any>(environment.configFile));
      ConfigurationManagerService.configSettings = { ...defaultConfig, ...envConfig };
    } catch (error) {
      throw new Error('Could not load configuration file');
    }
  }
}
